<template>
    <div
        class="date form-group"
        :class="{ 'is-empty': empty, 'is-disabled': readonly }"
        :data-element="element.id"
        :title="readonly ? $t('app.common.readonly') : ''"
    >
        <div class="d-flex justify-content-between align-items-center">
            <label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
                <span v-html="macro(label)"></span>
                <small v-if="required" class="required">*</small>
            </label>
            <div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
                <app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
            </div>
        </div>
        <div class="input-group">
            <DatePicker
                :v-model="value"
                @update:modelValue="update"
                :masks="{ input: format }"
                color="gray"
                class="datepicker"
            >
                <template v-slot="{ inputValue, inputEvents }">
                    <input
                        ref="datepicker"
                        class="form-control text-right"
                        :class="classes('input')"
                        :data-label="label"
                        :disabled="readonly"
                        :readonly="readonly"
                        :value="inputValue"
                        :required="required"
                        v-on="inputEvents"
                    />
                </template>
            </DatePicker>
            <div class="input-group-text" :class="classes('input')">
                <app-icon value="date"></app-icon>
            </div>
        </div>
        <div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }" ref="feedback">
            <span v-if="!valid">{{ $t('validation.mandatory') }}</span>
        </div>
        <small class="form-text" :class="classes('description')">
            <span v-if="description" v-html="macro(description)"></span>
            &nbsp;
        </small>
    </div>
</template>

<script>
    import store from '../../store'
    import { DatePicker } from 'v-calendar'

    export default {
        props: {
            definition: { type: Object, required: true },
            element: { type: Object, required: true }
        },
        computed: {
            description() {
                return typeof this.definition.description == 'string' ? this.definition.description : null
            },
            empty() {
                return !this.value
            },
            saved() {
                return this.element && this.date(this.element.value) != null
            },
            format() {
                return store.getters.dateformat('UTC')
            },
            label() {
                return this.definition.title
            },
            readonly() {
                return store.getters.readonly(this.definition, this.saved)
            },
            required() {
                return this.options('required') == true
            },
            valid() {
                return !(this.element && this.element.valid === false)
            },
            fieldVisibleOnlyInPreview() {
                return (
                    this.definition.print_visibility == 'preview' &&
                    store.state.preview == true &&
                    store.state.complete == false
                )
            }
        },
        data() {
            return { value: '' }
        },
        watch: {
            'element.value': {
                immediate: true,
                handler(value) {
                    this.value = this.date(value)
                    if (this.required && this.value && this.$refs && this.$refs.datepicker && this.$refs.feedback) {
                        this.$refs.datepicker.setCustomValidity('')
                        this.$refs.datepicker.classList.remove('is-valid', 'is-invalid')
                        this.$refs.datepicker.dispatchEvent(new Event('validation:reset'))
                        this.$validate(this.$refs.datepicker)
                        this.$refs.feedback.innerHTML = ''
                        this.$refs.feedback.classList.remove('d-inline-block')
                    }
                }
            }
        },
        methods: {
            classes(index) {
                return store.getters['classes'](index)
            },
            date(value) {
                try {
                    if (value && typeof value == 'string') {
                        let v = value.substring(0, 10).split('-')
                        if (v.length == 3) {
                            return new Date(v[0], v[1] - 1, v[2])
                        }
                    }
                    return null
                } catch (e) {
                    return null
                }
            },
            tostring(value) {
                let m = '' + (value.getMonth() + 1)
                let d = '' + value.getDate()
                let y = '' + value.getFullYear()
                if (m.length < 2) m = '0' + m
                if (d.length < 2) d = '0' + d

                return [y, m, d].join('-')
            },
            macro(value) {
                return store.getters['macro'](value)
            },
            options(value) {
                return store.getters['options'](this.definition, value)
            },
            update(value) {
                if (!this.readonly && (value || !this.required)) {
                    this.value = value
                    let v = this.value instanceof Date && !isNaN(this.value) ? this.tostring(this.value) : ''
                    let o = this.element.value ? this.element.value.substring(0, 10) : ''
                    if (v !== o) {
                        v = v == '' ? v : v + ' 00:00:00'
                        let gk = this.element.group + '|' + this.definition.group
                        store.commit('QUEUE', { id: this.element.id, group: gk, value: v })
                    }
                }
            },
            trans(key) {
                let trans = store.getters.trans(key)
                return trans ? trans : this.$t('front.' + key)
            }
        },
        components: { DatePicker }
    }
</script>
